import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllProjects: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects',
		defaultMessage: 'View all projects',
		description: 'Message for the view all projects menu item in the projects submenu',
	},
	moreProjects: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects',
		defaultMessage: 'More projects',
		description: 'Message for the more projects flyout in the projects submenu',
	},
	viewAllProjectsGalaxia: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects-galaxia',
		defaultMessage: 'View all spaces',
		description: 'Message for the view all projects menu item in the projects submenu',
	},
	moreProjectsGalaxia: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects-galaxia',
		defaultMessage: 'More spaces',
		description: 'Message for the more projects flyout in the projects submenu',
	},
});
